import {
	BeforeInsert,
	BeforeUpdate,
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
} from 'typeorm';
import { normalizePhoneToE164 } from '../../utils/validation';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('client_phone_phone_index', ['phone'], {})
@Index('client_phone_pk', ['fkClientId', 'phone'], { unique: true })
@Entity('client_phone')
export class ClientPhoneEntity extends BaseEntity {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: 'phone', length: 64 })
	public phone!: string;

	@ManyToOne(() => ClientEntity, (client) => client.clientPhones, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	// Belt-and-suspenders normalization for any write path that bypasses
	// `syncClientPhoneNumbers` (the primary normalization point). This
	// mapping table is the source of truth for caller-ID matching — it
	// must stay in canonical E.164 or the matcher's exact-string join
	// silently misses rows. If a value is unparseable, leave it alone
	// rather than blank it: better to surface bad data than discard it.
	@BeforeInsert()
	@BeforeUpdate()
	// `protected` (not `private`): this hook is invoked by TypeORM via the
	// @BeforeInsert/@BeforeUpdate decorators, not by direct calls, so TS
	// `noUnusedLocals` (TS6133) would wrongly flag a `private` version as unused.
	protected _normalizePhone(): void {
		if (this.phone != null && this.phone !== '') {
			const normalized = normalizePhoneToE164(this.phone);
			if (normalized != null) {
				this.phone = normalized;
			}
		}
	}
}
